import React, { Component } from 'react';
import { Card, Label, Button, FormGroup, CardHeader, CardBody, Row, Col, Table } from 'reactstrap';
import { numberWithCommas } from '../../lib/Utils';

import { Field, Form, reduxForm } from 'redux-form';

import { ReduxFileInput } from '../../components/ReduxInput';

const InvoiceTable = (props) => {

    const { quote, previous, onSubmit, handleSubmit, terminalName, remarks } = props;
    let total = "$0.00";
    let baseRate = "$0.00";
    let destination = "Base Rate";

    let itemized = [];
    if (quote && quote.items) {
        let i = 0;
        itemized = quote.items.map((item) => {
            let num = parseFloat(Math.round(item.rate * 100) / 100).toFixed(2);
            return (
                <tr key={i++}>
                    <td> {i}</td>
                    <td className="text-center"><strong>{item.count}</strong></td>
                    <td>{item.description}</td>
                    <td>{"$" + numberWithCommas(num)}</td>
                </tr>
            );
        });

        total = "$" + numberWithCommas(quote.total);
        baseRate = "$" + numberWithCommas(parseFloat(Math.round(quote.baseRate.rate * 100) / 100).toFixed(2));
        destination = quote.baseRate.destination;
    }
    return (
        <Table striped responsive>
            <thead>
                <tr>
                    <th className="center">#</th>
                    <th className="center">Quantity</th>
                    <th>Description</th>
                    <th className="center">Price</th>
                </tr>
            </thead>
            <tbody>
                {itemized}
                <tr>
                    <td />
                    <td className="text-center"><strong>1</strong></td>
                    <td>{terminalName + " to " + destination || "Base Rate"}</td>
                    <td>{baseRate}</td>
                </tr>
            </tbody>
        </Table>
    );

}

export default InvoiceTable;


// WEBPACK FOOTER //
// ./src/components/InvoiceTable/InvoiceTable.js